import React, { useState } from 'react'
import Header from '../../Header/header'
import './Asthma.css'
import { RiArrowRightSLine } from 'react-icons/ri'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img2 from '../../../assets/doc_img2.webp'

const Asthma = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const faqData = [
    {
      question: 'Who is the best asthma doctor in Pitampura?',
      answer: 'Dr Gaurav Pandey at Sharva Clinic is a trusted asthma specialist known for providing personalized and advanced asthma care.',
    },
    {
      question: ' What are common asthma symptoms',
      answer: 'Common symptoms include wheezing, coughing (especially at night), chest tightness, and shortness of breath.',
    },
    {
      question: 'Is asthma treatment safe for children?',
      answer: ' Yes, asthma treatment is completely safe when prescribed by a qualified asthma specialist in Pitam Pura.',
    },
    {
      question: 'Can asthma be permanently cured?',
      answer: ' Asthma cannot be permanently cured, but with proper asthma treatment in Pitampura, it can be effectively controlled.',
    },
    {
      question: 'How can I prevent asthma attacks?',
      answer: 'Avoid known triggers, take prescribed medications regularly, and attend follow-up appointments for proper monitoring.',
    },
  ]

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='asthmahero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Asthma
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Stronger Lungs. Healthier Life.
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                With the right treatment plan and ongoing support, you can prevent attacks and enjoy daily activities without fear.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Best Asthma Doctor in Pitampura – Sharva Clinic</h2>
              <p>
                If you are searching for the <span style={{ fontWeight: 'bold' }}>best asthma doctor in Pitampura</span>, Sharva Clinic provides
                advanced, patient-focused respiratory care for both children and adults. Asthma is a chronic lung condition that causes breathing
                difficulty, wheezing, coughing, and chest tightness. With proper diagnosis and structured management, asthma can be effectively
                controlled and patients can live a normal, active life.
              </p>
              <p>
                At Sharva Clinic, <span style={{ fontWeight: 'bold' }}>Dr Gaurav Pandey</span>, a trusted{' '}
                <span style={{ fontWeight: 'bold' }}>asthma specialist in Pitam Pura</span>, offers comprehensive evaluation and personalized care
                plans. Many patients ignore early symptoms such as frequent coughing at night, breathlessness during mild activity, or repeated chest
                infections. These signs should not be overlooked, as timely intervention helps prevent severe attacks.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Advanced Asthma Treatment in Pitampura</h3>
              <p>
                Our approach to <span style={{ fontWeight: 'bold' }}>asthma treatment in Pitampura</span> focuses on identifying triggers, assessing
                lung function, and designing customized treatment plans. Asthma may be triggered by dust, pollution, pollen, infections, weather
                changes, or allergies. Understanding the root cause helps in long-term control.
              </p>
              <p>At Sharva Clinic, we provide:</p>
              <ul>
                <li>Detailed asthma assessment</li>
                <li>Lung function testing and monitoring</li>
                <li>Personalized inhaler therapy guidance</li>
                <li>Allergy and trigger management</li>
                <li>Preventive asthma care plans</li>
                <li>Treatment for acute and chronic asthma</li>
              </ul>
              <p>
                Under the expert supervision of <span style={{ fontWeight: 'bold' }}>Dr Gaurav Pandey</span>, patients receive clear guidance on
                correct inhaler usage, medication schedules, and lifestyle modifications. Our goal is to reduce emergency visits, improve lung
                capacity, and ensure long-term symptom control.
              </p>
              <p>
                If you or your child experiences frequent breathlessness, repeated wheezing, or dependency on rescue inhalers, it is time to consult
                the <span style={{ fontWeight: 'bold' }}>best asthma doctor in Pitampura</span> at Sharva Clinic.
              </p>
              <p>Book your appointment today for reliable and effective asthma treatment in Pitampura.</p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Gaurav Pandey'
              specialty='Chest and Allergy Specialist'
              education='MD Pulmonary Medicine, Dip. Geriatric Medicine (MAMC), FCC (Cardiology)'
              image={doc_img2}
              blurb='Dr. Gaurav Pandey manages asthma and chronic respiratory conditions at Sharva Clinique with over 9 years of experience in pulmonary medicine.'
              profileLink='/drgaurav/asthma'
            />

            <div className='faq-container'>
              <h2 className='faq-title'>Frequently Asked Questions</h2>

              <div className='faq-list'>
                {faqData.map((item, index) => (
                  <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                    <div className='faq-question' onClick={() => toggleFAQ(index)}>
                      <h3>{item.question}</h3>
                      <span className='faq-icon'>{activeIndex === index ? '−' : '+'}</span>
                    </div>

                    <div className='faq-answer-wrapper'>
                      <div className='faq-answer'>
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>
            <div className='card1'>
              <p>
                “Professional staff and a very clean clinic environment. The asthma action plan they gave me is simple and easy to follow. I finally
                feel in control of my condition.”
              </p>
              <p> — Sandeep </p>
            </div>
            <div className='card2'>
              <p>
                “My child’s asthma was getting worse, but after starting treatment here, we’ve seen real improvement. The doctors are compassionate
                and truly care about their patients.”
              </p>
              <p>— Neha </p>
            </div>
            <div className='card3'>
              <p>
                “I appreciate how thorough the consultation was. They didn’t just prescribe medicine, they educated me about lifestyle changes and
                prevention. My asthma attacks have reduced a lot.”
              </p>
              <p> — Anjali</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Asthma
